"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _ColorPreview = _interopRequireDefault(require("../ColorPreview"));

require("./styles/_color-input-section.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ColorInputSection(_ref) {
  var titleName = _ref.titleName,
      titlePlaceHolder = _ref.titlePlaceHolder,
      handleChangeTitle = _ref.handleChangeTitle,
      handleAddMoreButtonClick = _ref.handleAddMoreButtonClick,
      handleRemoveClick = _ref.handleRemoveClick,
      index = _ref.index,
      handleSaveColor = _ref.handleSaveColor,
      colors = _ref.colors;
  return /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "color-input-section"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
    autoGrow: true,
    prefix: "edit",
    defaultValue: titleName || 'Untitled',
    onChange: handleChangeTitle,
    label: "Group Name"
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    type: "TERTIARY",
    prefix: "addfat",
    onClick: handleAddMoreButtonClick,
    tooltipLabel: "Add another colour to this group",
    tooltipId: "".concat(index, "-add")
  })), colors.map(function (_ref2, colorIndex) {
    var subBrandColorId = _ref2.subBrandColorId,
        key = _ref2.key,
        hexCode = _ref2.hexCode,
        name = _ref2.name,
        buttonText = _ref2.buttonText;
    return /*#__PURE__*/_react.default.createElement(_ColorPreview.default, {
      key: subBrandColorId || key,
      hexCode: hexCode,
      colorName: name,
      index: colorIndex,
      handleSaveColor: handleSaveColor(colorIndex),
      handleRemoveClick: handleRemoveClick(colorIndex),
      buttonText: buttonText,
      isSecondarySection: index !== 0
    });
  }));
}

var _default = (0, _react.memo)(ColorInputSection);

exports.default = _default;